function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgConversivel = function SvgConversivel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.482.56a.6.6 0 01.82-.217l6.157 3.59a.6.6 0 01.137.109h1.163a3.8 3.8 0 01.925.114l4.45 1.117a2.2 2.2 0 011.249.847l.912 1.264A3.014 3.014 0 0132 11.259l-.428-.42.428.42c-.34.346-.804.541-1.289.541h-1.965a3.401 3.401 0 01-6.694 0H10.83a3.4 3.4 0 01-6.706-.068L1.575 11.4A1.4 1.4 0 01.4 10.018V7.921a.6.6 0 01.05-.24l.57-1.3v-.939a1.4 1.4 0 011.4-1.4h3.432l-.17-1.39a.6.6 0 011.19-.145l.189 1.535h5.455l-.55-1.824a.6.6 0 011.149-.346l.654 2.17h7.495L16.698 1.38a.6.6 0 01-.216-.82zM4.15 10.524a3.401 3.401 0 016.68.075h11.223a3.401 3.401 0 016.694 0h1.965a.607.607 0 00.433-.182c.62-.63.694-1.615.177-2.332l-.912-1.264a1 1 0 00-.568-.385l-4.45-1.117a2.6 2.6 0 00-.633-.078H2.42a.2.2 0 00-.2.2v1.065a.6.6 0 01-.05.241l-.57 1.299v1.971a.2.2 0 00.153.194l2.398.313zm10.12-3.63a.6.6 0 01.6-.6h2.33a.6.6 0 110 1.2h-2.33a.6.6 0 01-.6-.6zM7.483 9a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4zM25.4 9a2.2 2.2 0 100 4.4 2.2 2.2 0 000-4.4z",
    fill: props.color
  }));
};
SvgConversivel.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgConversivel.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgConversivel;